export var LoadingStatsTypes;
(function (LoadingStatsTypes) {
    LoadingStatsTypes["startTime"] = "startTime";
    LoadingStatsTypes["endTime"] = "endTime";
    LoadingStatsTypes["partFirstInit"] = "partFirstInit";
    LoadingStatsTypes["partInitRequest"] = "partInitRequest";
    LoadingStatsTypes["partBeforeLoader"] = "partBeforeLoader";
    LoadingStatsTypes["partLoadingAssets"] = "partLoadingAssets";
    LoadingStatsTypes["partSecondInit"] = "partSecondInit";
})(LoadingStatsTypes || (LoadingStatsTypes = {}));
//# sourceMappingURL=index.js.map